import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type { GetEnvelopeResponse } from './get-envelope.types'

export const getEnvelopeQueryKey = (envelopeId: string) => [
  'envelope',
  envelopeId,
]

// Exported for imperative reuse (queryClient.fetchQuery), like uploadDocument
export const getEnvelope = async (
  envelopeId: string,
): Promise<GetEnvelopeResponse> => {
  const response = await apiClient.get<GetEnvelopeResponse>(
    `/v1/ecm/envelopes/${envelopeId}`,
  )
  return response.data
}

export const useGetEnvelope = (envelopeId: string, enabled = true) => {
  return useQuery({
    queryKey: getEnvelopeQueryKey(envelopeId),
    queryFn: () => getEnvelope(envelopeId),
    enabled,
  })
}
